__turbopack_context__.v({
  "container": "PEcZoG_container",
  "content": "PEcZoG_content",
});
